import SupportController                from 'scripts/defa/support/controller-support-controller';
import SupportRouter                    from 'scripts/defa/support/router-support-router';
import SupportContainer                 from 'scripts/defa/support/view-support-container';
import SupportResponseCollectionView    from 'scripts/defa/support/view-support-response-collection-view';
import SupportResponseFunctionalityView from 'scripts/defa/support/view-support-response-functionality-view';
import SupportResponseSnippet           from 'scripts/defa/support/view-support-response-snippet';
import SupportSearchForm                from 'scripts/defa/support/view-support-search-form';
import Module                           from 'scripts/module';

const SupportModule = new Module('SupportModule',{
	controllers: {
		SupportController
	},
	routers    : {
		SupportRouter
	},
	views      : {
		SupportContainer,
		SupportResponseCollectionView,
		SupportResponseFunctionalityView,
		SupportResponseSnippet,
		SupportSearchForm
	}
});
export default SupportModule;